<template>
    <div class="form-group" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <flat-pickr
            v-model="value"
            class="form-control flatpickr-input"
            :name="name"
            :id="name"
            :placeholder="placeholder"
            :config="config"
            :disabled="disabled"
            @update:modelValue="updateField"
        ></flat-pickr>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import { French } from 'flatpickr/dist/l10n/fr.js';

export default {
    name: "FormMonthPicker",
    components: {
        flatPickr
    },
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        labelHidden: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: 'mm/aaaa'
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        },
        data: {
            required: false,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            value: null,
            config: {
                altInput: true,
                dateFormat: 'Y-m',
                altFormat: 'F Y',
                disableMobile: true,
                locale: French,
                plugins: [
                    new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: 'Y-m',
                        altFormat: 'F Y',
                    })
                ],
            },
        }
    },
    methods: {
        updateField() {
            this.$emit("update:field", this.value);
        },
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                this.value = newVal;
            },
        }
    }
}
</script>

<style scoped>

</style>
